module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btnNovaCategoria",
    attrs: {
      "to": {
        name: 'Nova Categoria de Servicos'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btnNovaCategoria"
  }, [_c('i', {
    staticClass: "fa fa-plus paddingRight"
  }), _vm._v("Nova Categoria\n                  ")])]), _vm._v(" "), _c('router-link', {
    staticClass: "btnNovaCategoria",
    attrs: {
      "to": {
        name: 'orderCategoria',
        params: {
          categoriasFiltered: _vm.categoriasFiltered
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-success btnNovaCategoria"
  }, [_c('i', {
    staticClass: "fa fa-list-ol paddingRight"
  }), _vm._v("Ordenar Categorias\n                  ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderCategoria(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.categoriasFiltered), function(c) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(c.id))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(c.descricao))]), _vm._v(" "), _c('td', [_c('img', {
      staticClass: "url_imagem",
      attrs: {
        "src": c.imagem
      }
    })]), _vm._v(" "), _c('td', [_c('i', {
      class: 'fa fa-circle ativo_' + c.ativo,
      attrs: {
        "aria-hidden": "true",
        "title": ""
      }
    })]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "grupo_btn_acoes"
    }, [_c('router-link', {
      staticClass: "btn_editar",
      attrs: {
        "to": {
          name: 'editarCategoriadeServicos',
          params: {
            id: c.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash-o btn_excluir",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.excluirCategoria(c.id)
        }
      }
    })], 1)])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.orderCategoria(coluna)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ucwords")(coluna)))])])
  }), 0)])])])])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0707bebe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ServicoCategorias/ServicoCategorias.vue
// module id = 1198
// module chunks = 1